export function initLayoutVars() {
	window.addEventListener('load', () => {
		const wpadminbar = document.getElementById('wpadminbar');
		const header = document.querySelector('header.wp-block-template-part');

		if (wpadminbar) {
			document.documentElement.style.setProperty('--wpadminbar-height', `${wpadminbar.clientHeight}px`);
		}

		if (header) {
			document.documentElement.style.setProperty('--header-height', `${header.clientHeight}px`);
		}
	});
}
